import { SquarePlay, Video } from "lucide-react";
import { useState } from "react";
import { isProSubscription } from "../../../hooks/utils";
import { useAppDispatch } from "../../../store/hooks";
import { pushModal } from "../../../store/slices/modalsSlice";
import Animation from "../../Animation";
import SubscriptionCTA from "../../Modals/SubscriptionCTA";
import CreateLesson from "./CreateLesson";
// import styles from "./CreateLessonWrapper.module.css";
import CreateLiveLesson from "./CreateLiveLesson";

export const enum LessonType {
  Recorded = "recorded",
  Live = "live",
}

const CreateLessonWrapper = () => {
  const [sessionType, setSessionType] = useState<LessonType | null>();
  const dispatch = useAppDispatch();

  if (sessionType === LessonType.Recorded)
    return <CreateLesson setSessionType={setSessionType} />;
  if (sessionType === LessonType.Live)
    return <CreateLiveLesson setSessionType={setSessionType} />;

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold">
          نشر حصة جديدة
        </h3>
        <div className="flex flex-wrap justify-center p-3 gap-6 bg-white border rounded-lg shadow-sm">
          <button
            className={`size-30 border rounded-lg p-3 flex flex-col items-center justify-center ${
              isProSubscription()
                ? "border-teal-400 bg-teal-50 text-primary hover:bg-teal-100 hover:cursor-pointer"
                : "bg-gray-300 text-black border border-black opacity-50"
            }`}
            onClick={() => {
              if (isProSubscription()) setSessionType(LessonType.Live);
              else dispatch(pushModal(<SubscriptionCTA />));
            }}
          >
            <Video className="size-14" />
            <p className="mt-2">حصة لايف</p>
          </button>

          <button
            className="size-30 border border-teal-400 bg-teal-50 text-primary hover:bg-teal-100 hover:cursor-pointer rounded-lg p-3 flex flex-col items-center justify-center"
            onClick={() => setSessionType(LessonType.Recorded)}
          >
            <SquarePlay className="size-14" />
            <p className="mt-2">حصة مسجلة</p>
          </button>
        </div>
      </div>
    </Animation>
  );
};

export default CreateLessonWrapper;
